import { tv } from "tailwind-variants";

export const contentBlock = tv({
    base: [
        "tw:shadow-card tw:rounded-md tw:border-none tw:transition-transform tw:h-full tw:flex tw:flex-col tw:justify-start",
        "tw:hover:shadow-card-active tw:hover:scale-102"
    ],
    variants: {
        expandImage: {
            true: "",
            false: "tw:p-4"
        }
    }
});
